import { sendGAEvent } from '@next/third-parties/google'
import type { IAnalyticsAdapter, TAnalyticsEvent } from './types'

export const GoogleAnalyticsAdapter: IAnalyticsAdapter = {
  trackEvent: ({ name, properties }: TAnalyticsEvent) => {
    if (typeof window === 'undefined') return
    sendGAEvent('event', name, { ...properties })
  },
}
